<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>単価情報</mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <form [formGroup]="tankatableMeisaiInfoForm">
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field appearance="fill"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[13%] tw-md:max-w-[full]">
                    <mat-label>適用開始年月</mat-label>
                    <input matInput type="month" formControlName="applyStartyearmonth" class="font-color-display-only"
                        autocomplete="off">
                </mat-form-field>
                <mat-form-field appearance="fill"
                    class="input-form-date tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[13%] tw-md:max-w-[full]">
                    <mat-label>適用終了年月</mat-label>
                    <input matInput readonly="true" [disabled]="true" id="applyEndyearmonth"
                        [value]="tankatableMeisaiInfoForm.get('applyEndyearmonth').value | dateYmStringSg"
                        class="font-color-display-only" autocomplete="off">
                </mat-form-field>
            </div>
            <div formArrayName="items">
                <!-- <div [formGroupName]="tankatableMeisaiInfoForm.controls.items"> -->
                <div *ngFor="let item of items.controls; let i = index" [formGroupName]="i"
                    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                    <mat-form-field appearance="fill"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[40%] tw-lg:max-w-[full]">
                        <mat-label>単価正式名</mat-label>
                        <input matInput readonly="true" formControlName="tankaAname" autocomplete="off"
                            class="font-color-display-only" />
                    </mat-form-field>
                    <mat-form-field appearance="fill"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[16%] tw-lg:max-w-[full]">
                        <mat-label>使用量（下限）</mat-label>
                        <input matInput readonly="true" id="displayTankaRangeStart" style="text-align:right"
                            [disabled]="true" [value]="item.get('displayTankaRangeStart').value | number:'1.1-1'"
                            autocomplete="off" class="font-color-display-only" />
                        <span matSuffix class="tw-ml-[5px]">㎥</span>
                    </mat-form-field>
                    <mat-form-field appearance="fill"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[16%] tw-lg:max-w-[full]">
                        <mat-label>使用量（上限）</mat-label>
                        <input matInput readonly="true" id="displayUnitPriceRangeEnd" style="text-align:right"
                            [disabled]="true" [value]="item.get('displayUnitPriceRangeEnd').value | number:'1.1-1'"
                            autocomplete="off" class="font-color-display-only" />
                        <span matSuffix class="tw-ml-[5px]">㎥</span>
                    </mat-form-field>
                    <mat-form-field appearance="fill"
                        class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[16%] tw-lg:max-w-[full]">
                        <mat-label>単価</mat-label>
                        <input matInput autocomplete="off" formControlName="tanka" style="text-align:right"
                            class="font-color-display-only" autocomplete="off" (blur)="onBlurNumberComma($event, i)"
                            (focus)="onFocusNumberComma($event, i)" [maxlength]="numberCommaMaxLength" />
                        <span matSuffix class="tw-ml-[5px]">円</span>
                    </mat-form-field>
                </div>
                <!-- </div> -->
            </div>
        </form>
    </mat-card-content>
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
        <mat-card-actions class="btn_area_right">
            <div class="tw-flex tw-flex-col tw-box-border tw-justify-end tw-items-end tw-content-end">
                <div class="button-container">
                    <button *ngIf="isRegistVisible" type="submit" mat-raised-button color="primary" class="btn"
                        (click)="onClickRegistration()" [disabled]="parentForm.invalid" id="regist">登録</button>
                    <button *ngIf="isDeleteVisible" type="submit" mat-raised-button color="primary" class="btn"
                        (click)="onClickDelete()" id="delete">取消</button>
                    <button *ngIf="isApproveVisible" type="submit" mat-raised-button color="primary" class="btn"
                        (click)="onClickApproval()" id="approve">承認</button>
                </div>
                <div class="button-container">
                    <button type="button" mat-raised-button color="primary" class="btn" (click)="goToPrevious()"
                        id="back"> 戻る
                    </button>
                </div>
            </div>
        </mat-card-actions>
    </div>
</mat-card>